export enum AuthCodeStatus {
  PENDING,
  VALIDATING,
  VALID,
  INVALID,
  LOGIN_ERROR,
  CODE_EXPIRED,
}
